import type { BoardModel } from '../../models/board/BoardModel';
import type { BoardView } from '../../views/board/BoardView';
import { CoinBlockerModel } from '../../models/blockers/CoinBlockerModel';
import type { App } from '../../../../app/App';
import { IAPPlacement } from '../../../../app/iap/types';
import { openShopPopup } from '../../../../behaviours/openShopPopup';
import { openUnlockBlockerPopup } from '../../../../behaviours/openUnlockBlockerPopup';

export interface CoinBlockerConfig {
  model: BoardModel;
  view: BoardView;
  app: App;
  isInBoosterMode: () => boolean;
}

export class CoinBlockerController {
  constructor(config: CoinBlockerConfig) {
    this.init(config);
  }

  private init({ model, view, app, isInBoosterMode }: CoinBlockerConfig): void {
    view.onStackTapped.connect(async (stack) => {
      if (isInBoosterMode()) return;

      if (!(stack.blocker instanceof CoinBlockerModel)) return;

      const price = stack.blocker.getPrice();

      if (await openUnlockBlockerPopup(app, { price })) {
        if (!app.resources.canAfford(price)) {
          void openShopPopup(app, IAPPlacement.Level, true);
          return;
        }
        app.resources.payForCoinBlockerRemoval(price);

        model.removeBlocker(stack, stack.blocker);
      }
    });
  }
}
